import {
    ADD_CUSTOMER_PROGRESS, ADD_CYLINDER_HOLDING_LIMIT_PROGRESS,
    ADD_CYLINDER_PROGRESS, ADD_INDUSTRY_PROGRESS, ADD_UNIT_PROGRESS,
    ADD_RATE_PROGRESS, ADD_RM_PROGRESS, ADD_ACCOUNT_MANAGER_PROGRESS,
    ADD_UOM_CONVERSION_PROGRESS, ADD_UOM_PROGRESS, EDIT_DELETE_CUSTOMER_PROGRESS,
    EDIT_DELETE_CYLINDER_HOLDING_LIMIT_PROGRESS, EDIT_DELETE_CYLINDER_PROGRESS, EDIT_DELETE_INDUSTRY_PROGRESS,
    EDIT_DELETE_UNIT_PROGRESS, EDIT_DELETE_RATE_PROGRESS, EDIT_DELETE_RM_PROGRESS,
    EDIT_DELETE_ACCOUNT_MANAGER_PROGRESS, EDIT_DELETE_UOM_CONVERSION_PROGRESS, EDIT_DELETE_UOM_PROGRESS,
    GET_CUSTOMER_LIST_PROGRESS, GET_CYLINDER_HOLDING_LIMIT_LIST_PROGRESS, GET_CYLINDER_LIST_PROGRESS,
    GET_INDUSTRY_LIST_PROGRESS, GET_UNIT_LIST_PROGRESS, GET_RATE_LIST_PROGRESS, GET_RM_LIST_PROGRESS,
    GET_ACCOUNT_MANAGER_LIST_PROGRESS, GET_UOM_CONVERSION_LIST_PROGRESS, GET_UOM_LIST_PROGRESS, LOGIN_PROGRESS,
    LOGOUT_PROGRESS, GET_DELIVERY_CHALLAN_LIST_PROGRESS, ADD_DELIVERY_CHALLAN_PROGRESS, EDIT_DELETE_DELIVERY_CHALLAN_PROGRESS,
    GET_SUPPLIER_LIST_PROGRESS, ADD_SUPPLIER_PROGRESS, EDIT_DELETE_SUPPLIER_PROGRESS,
    GET_DRIVER_LIST_PROGRESS, ADD_DRIVER_PROGRESS, EDIT_DELETE_DRIVER_PROGRESS,
    GET_PRODUCT_LIST_PROGRESS, ADD_PRODUCT_PROGRESS, EDIT_DELETE_PRODUCT_PROGRESS,
    GET_SCHEDULE_ENTRY_LIST_PROGRESS, ADD_SCHEDULE_ENTRY_PROGRESS, EDIT_DELETE_SCHEDULE_ENTRY_PROGRESS,
    GET_GRN_LIST_PROGRESS, ADD_GRN_PROGRESS, EDIT_DELETE_GRN_PROGRESS,
    GET_CUSTOMER_PO_LIST_PROGRESS,
    ADD_CUSTOMER_PO_PROGRESS,
    EDIT_DELETE_CUSTOMER_PO_PROGRESS,
    GET_PRODUCTION_PLANNING_LIST_PROGRESS,ADD_PRODUCTION_PLANNING_PROGRESS,EDIT_DELETE_PRODUCTION_PLANNING_PROGRESS,
    GET_CYLINDER_INWARD_LIST_PROGRESS,ADD_CYLINDER_INWARD_PROGRESS,EDIT_DELETE_CYLINDER_INWARD_PROGRESS,
    GET_BOM_LIST_PROGRESS,ADD_BOM_PROGRESS,EDIT_DELETE_BOM_PROGRESS
    ,ADD_IMPORT_CUSTOMER_PROGRESS,
    ADD_IMPORT_SUPPLIER_PROGRESS,
    GET_CUSTOMER_TYPE_LIST_PROGRESS,
    ADD_CUSTOMER_TYPE_PROGRESS,
    EDIT_DELETE_CUSTOMER_TYPE_PROGRESS,
    GET_CYLINDER_STATUS_LIST_PROGRESS,
    ADD_CYLINDER_STATUS_PROGRESS,
    EDIT_DELETE_CYLINDER_STATUS_PROGRESS,
    GET_PRODUCTION_ENTRY_LIST_PROGRESS,
    ADD_PRODUCTION_ENTRY_PROGRESS,
    EDIT_DELETE_PRODUCTION_ENTRY_PROGRESS,
    GET_QUALITY_ENTRY_LIST_PROGRESS,
    ADD_QUALITY_ENTRY_PROGRESS,
    EDIT_DELETE_QUALITY_ENTRY_PROGRESS,
    GET_DELIVERY_ORDER_LIST_PROGRESS,
    ADD_DELIVERY_ORDER_PROGRESS,
    EDIT_DELETE_DELIVERY_ORDER_PROGRESS,
    GET_LOCATION_LIST_PROGRESS,
    ADD_LOCATION_PROGRESS,
    EDIT_DELETE_LOCATION_PROGRESS,
    EDIT_DELETE_CPD_PROGRESS,
    ADD_CPD_PROGRESS,
    GET_CPD_LIST_PROGRESS,
    GET_CUSTOMER_CATEGORY_LIST_PROGRESS,
    ADD_CUSTOMER_CATEGORY_PROGRESS,
    EDIT_DELETE_CUSTOMER_CATEGORY_PROGRESS,
    GET_ECI_LIST_PROGRESS,
    ADD_ECI_PROGRESS,
    EDIT_DELETE_ECI_PROGRESS,
    EDIT_DELETE_INTERNAL_MOVEMENT_PROGRESS,
    ADD_INTERNAL_MOVEMENT_PROGRESS,
    GET_INTERNAL_MOVEMENT_LIST_PROGRESS,
    GET_VEHICLE_LIST_PROGRESS,
    ADD_VEHICLE_PROGRESS,
    EDIT_DELETE_VEHICLE_PROGRESS,
    GET_ROUTE_LIST_PROGRESS,
    ADD_ROUTE_PROGRESS,
    EDIT_DELETE_ROUTE_PROGRESS,
    GET_USER_LIST_PROGRESS,
    ADD_USER_PROGRESS,
    EDIT_DELETE_USER_PROGRESS,
    GET_DEPOT_LIST_PROGRESS,

    ADD_DEPOT_PROGRESS,
    EDIT_DELETE_DEPOT_PROGRESS,
    ADD_CYLINDER_CSV_PROGRESS,

    GET_CYLINDER_TAG_MAPPING_LIST_PROGRESS,
    ADD_CYLINDER_TAG_MAPPING_PROGRESS,
    EDIT_DELETE_CYLINDER_TAG_MAPPING_PROGRESS,

    GET_DELIVERY_CUSTOMER_CHALLAN_LIST_PROGRESS,
    ADD_DELIVERY_CUSTOMER_CHALLAN_PROGRESS,
    EDIT_DELETE_DELIVERY_CUSTOMER_CHALLAN_PROGRESS,
    GET_CUSTOMER_DELIVERY_CHALLAN_LIST_PROGRESS,
    ADD_CUSTOMER_DELIVERY_CHALLAN_PROGRESS,
    EDIT_CUSTOMER_DELETE_DELIVERY_CHALLAN_PROGRESS,
    GET_DELIVERY_CHALLAN_CUSTOMER_LIST_PROGRESS,
    ADD_DELIVERY_CHALLAN_CUSTOMER_PROGRESS,
    EDIT_DELETE_DELIVERY_CHALLAN_CUSTOMER_PROGRESS,
    GET_PICKUP_LIST_PROGRESS,
    ADD_PICKUP_PROGRESS,
    EDIT_DELETE_PICKUP_PROGRESS,
    



} from "../types/actionTypes";

export const login = (record) => ({
    type: LOGIN_PROGRESS,
    payload: record,
});

export const logout = (record) => ({
    type: LOGOUT_PROGRESS,
    payload: record,
});

// ====================== customer Master ===============================

export const getCustomerList = (record) => {
    return {
        type: GET_CUSTOMER_LIST_PROGRESS,
        payload: record,
    };
}

export const addCustomer = (record) => ({
    type: ADD_CUSTOMER_PROGRESS,
    payload: record,
});

export const editDeleteCustomer = (record) => ({
    type: EDIT_DELETE_CUSTOMER_PROGRESS,
    payload: record,
});

export const addImportCustomer = (record) => ({
    type: ADD_IMPORT_CUSTOMER_PROGRESS,
    payload: record,
});
// ====================== Cylinder holding limit Master ===============================

export const getCylinderHoldingLimitList = (record) => {
    return {
        type: GET_CYLINDER_HOLDING_LIMIT_LIST_PROGRESS,
        payload: record,
    };
}

export const addCylinderHoldingLimit = (record) => ({
    type: ADD_CYLINDER_HOLDING_LIMIT_PROGRESS,
    payload: record,
});

export const editDeleteCylinderHoldingLimit = (record) => ({
    type: EDIT_DELETE_CYLINDER_HOLDING_LIMIT_PROGRESS,
    payload: record,
});

// ====================== cylinder Master ===============================

export const getCylinderList = (record) => {
    return {
        type: GET_CYLINDER_LIST_PROGRESS,
        payload: record,
    };
}

export const addCylinder = (record) => ({
    type: ADD_CYLINDER_PROGRESS,
    payload: record,
});

export const addCylindercsv = (record) => ({
    type: ADD_CYLINDER_CSV_PROGRESS,
    payload: record,
});

export const editDeleteCylinder = (record) => ({
    type: EDIT_DELETE_CYLINDER_PROGRESS,
    payload: record,
});

// ====================== Industry Master ===============================

export const getIndustryList = (record) => {
    return {
        type: GET_INDUSTRY_LIST_PROGRESS,
        payload: record,
    };
}

export const addIndustry = (record) => ({
    type: ADD_INDUSTRY_PROGRESS,
    payload: record,
});

export const editDeleteIndustry = (record) => ({
    type: EDIT_DELETE_INDUSTRY_PROGRESS,
    payload: record,
});


// ====================== cYLINDER tAG MAP Master ===============================

export const getCylinderTagMapList = (record) => {
    return {
        type: GET_CYLINDER_TAG_MAPPING_LIST_PROGRESS,
        payload: record,
    };
}

export const addCylinderTagMap = (record) => ({
    type: ADD_CYLINDER_TAG_MAPPING_PROGRESS,
    payload: record,
});

export const editDeleteCylinderTagMap = (record) => ({
    type: EDIT_DELETE_CYLINDER_TAG_MAPPING_PROGRESS,
    payload: record,
});


// ====================== Customer Type Master ===============================

export const getCustomerTypeList = (record) => {
    return {
        type: GET_CUSTOMER_TYPE_LIST_PROGRESS,
        payload: record,
    };
}

export const addCustomerType = (record) => ({
    type: ADD_CUSTOMER_TYPE_PROGRESS,
    payload: record,
});

export const editDeleteCustomerType = (record) => ({
    type: EDIT_DELETE_CUSTOMER_TYPE_PROGRESS,
    payload: record,
});

// ====================== Customer Category Master ===============================

export const getCustomerCategoryList = (record) => {
    return {
        type: GET_CUSTOMER_CATEGORY_LIST_PROGRESS,
        payload: record,
    };
}

export const addCustomerCategory = (record) => ({
    type: ADD_CUSTOMER_CATEGORY_PROGRESS,
    payload: record,
});

export const editDeleteCustomerCategory = (record) => ({
    type: EDIT_DELETE_CUSTOMER_CATEGORY_PROGRESS,
    payload: record,
});

// ====================== Cylinder Status Master ===============================

export const getCylinderStatusList = (record) => {
    return {
        type: GET_CYLINDER_STATUS_LIST_PROGRESS,
        payload: record,
    };
}

export const addCylinderStatus = (record) => ({
    type: ADD_CYLINDER_STATUS_PROGRESS,
    payload: record,
});

export const editDeleteCylinderStatus = (record) => ({
    type: EDIT_DELETE_CYLINDER_STATUS_PROGRESS,
    payload: record,
});


// ====================== Unit Master ===============================

export const getUnitList = (record) => {
    return {
        type: GET_UNIT_LIST_PROGRESS,
        payload: record,
    };
}

export const addUnit = (record) => ({
    type: ADD_UNIT_PROGRESS,
    payload: record,
});

export const editDeleteUnit = (record) => ({
    type: EDIT_DELETE_UNIT_PROGRESS,
    payload: record,
});

// ====================== Depot Master ===============================

export const getDepotList = (record) => {
    return {
        type: GET_DEPOT_LIST_PROGRESS,
        payload: record,
    };
}

export const addDepot = (record) => ({
    type: ADD_DEPOT_PROGRESS,
    payload: record,
});

export const editDeleteDepot = (record) => ({
    type: EDIT_DELETE_DEPOT_PROGRESS,
    payload: record,
});

// ====================== Rate Master ===============================

export const getRateList = (record) => {
    return {
        type: GET_RATE_LIST_PROGRESS,
        payload: record,
    };
}

export const addRate = (record) => ({
    type: ADD_RATE_PROGRESS,
    payload: record,
});

export const editDeleteRate = (record) => ({
    type: EDIT_DELETE_RATE_PROGRESS,
    payload: record,
});

// ====================== RM Master ===============================

export const getRMList = (record) => {
    return {
        type: GET_RM_LIST_PROGRESS,
        payload: record,
    };
}

export const addRM = (record) => ({
    type: ADD_RM_PROGRESS,
    payload: record,
});

export const editDeleteRM = (record) => ({
    type: EDIT_DELETE_RM_PROGRESS,
    payload: record,
});

// ====================== Account Manager Master ===============================

export const getAccountManagerList = (record) => {
    return {
        type: GET_ACCOUNT_MANAGER_LIST_PROGRESS,
        payload: record,
    };
}

export const addAccountManager = (record) => ({
    type: ADD_ACCOUNT_MANAGER_PROGRESS,
    payload: record,
});

export const editDeleteAccountManager = (record) => ({
    type: EDIT_DELETE_ACCOUNT_MANAGER_PROGRESS,
    payload: record,
});

// ====================== Customer Product Details Master ===============================

export const getCpdList = (record) => {
    return {
        type: GET_CPD_LIST_PROGRESS,
        payload: record,
    };
}

export const addCpd = (record) => ({
    type: ADD_CPD_PROGRESS,
    payload: record,
});

export const editDeleteCpd = (record) => ({
    type: EDIT_DELETE_CPD_PROGRESS,
    payload: record,
});

// ====================== UOM Master ===============================

export const getUOMList = (record) => {
    return {
        type: GET_UOM_LIST_PROGRESS,
        payload: record,
    };
}

export const addUOM = (record) => ({
    type: ADD_UOM_PROGRESS,
    payload: record,
});

export const editDeleteUOM = (record) => ({
    type: EDIT_DELETE_UOM_PROGRESS,
    payload: record,
});

// ====================== UOM Conversion Master ===============================

export const getUOMConversionList = (record) => {
    return {
        type: GET_UOM_CONVERSION_LIST_PROGRESS,
        payload: record,
    };
}

export const addUOMConversion = (record) => ({
    type: ADD_UOM_CONVERSION_PROGRESS,
    payload: record,
});

export const editDeleteUOMConversion = (record) => ({
    type: EDIT_DELETE_UOM_CONVERSION_PROGRESS,
    payload: record,
});



// ====================== Location Master ===============================

export const getLocationList = (record) => {
    return {
        type: GET_LOCATION_LIST_PROGRESS,
        payload: record,
    };
}

export const addLocation = (record) => ({
    type: ADD_LOCATION_PROGRESS,
    payload: record,
});

export const editDeleteLocation = (record) => ({
    type: EDIT_DELETE_LOCATION_PROGRESS,
    payload: record,
});


// ====================== Supplier Master ===============================

export const getSupplierList = (record) => {
    return {
        type: GET_SUPPLIER_LIST_PROGRESS,
        payload: record,
    };
}

export const addSupplier = (record) => ({
    type: ADD_SUPPLIER_PROGRESS,
    payload: record,
});

export const editDeleteSupplier = (record) => ({
    type: EDIT_DELETE_SUPPLIER_PROGRESS,
    payload: record,
});
export const addImportSupplier = (record) => ({
    type: ADD_IMPORT_SUPPLIER_PROGRESS,
    payload: record,
});


// ====================== Driver Master ===============================

export const getDriverList = (record) => {
    return {
        type: GET_DRIVER_LIST_PROGRESS,
        payload: record,
    };
}

export const addDriver = (record) => ({
    type: ADD_DRIVER_PROGRESS,
    payload: record,
});

export const editDeleteDriver = (record) => ({
    type: EDIT_DELETE_DRIVER_PROGRESS,
    payload: record,
});

// ====================== User Master ===============================

export const getUserList = (record) => {
    return {
        type: GET_USER_LIST_PROGRESS,
        payload: record,
    };
}

export const addUser = (record) => ({
    type: ADD_USER_PROGRESS,
    payload: record,
});

export const editDeleteUser = (record) => ({
    type: EDIT_DELETE_USER_PROGRESS,
    payload: record,
});

// ====================== Vehicle Master ===============================

export const getVehicleList = (record) => {
    return {
        type: GET_VEHICLE_LIST_PROGRESS,
        payload: record,
    };
}

export const addVehicle = (record) => ({
    type: ADD_VEHICLE_PROGRESS,
    payload: record,
});

export const editDeleteVehicle = (record) => ({
    type: EDIT_DELETE_VEHICLE_PROGRESS,
    payload: record,
});

// ====================== Route Master ===============================

export const getRouteList = (record) => {
    return {
        type: GET_ROUTE_LIST_PROGRESS,
        payload: record,
    };
}

export const addRoute = (record) => ({
    type: ADD_ROUTE_PROGRESS,
    payload: record,
});

export const editDeleteRoute = (record) => ({
    type: EDIT_DELETE_ROUTE_PROGRESS,
    payload: record,
});


// ====================== Product Master ===============================

export const getProductList = (record) => {
    return {
        type: GET_PRODUCT_LIST_PROGRESS,
        payload: record,
    };
}

export const addProduct = (record) => ({
    type: ADD_PRODUCT_PROGRESS,
    payload: record,
});

export const editDeleteProduct = (record) => ({
    type: EDIT_DELETE_PRODUCT_PROGRESS,
    payload: record,
});



// ======================    Transactions    ===============================

// ====================== Delivery Challan  cutomer  ===============================

export const getDeliverycustomerChallanList = (record) => {
    return {
        type:GET_DELIVERY_CHALLAN_CUSTOMER_LIST_PROGRESS,
        payload: record,
    };
}

export const addDeliverycustomerChallan = (record) => ({
    type: ADD_DELIVERY_CHALLAN_CUSTOMER_PROGRESS,
    payload: record,
});

export const editDeleteDeliverycustomerChallan = (record) => ({
    type: EDIT_DELETE_DELIVERY_CHALLAN_CUSTOMER_PROGRESS,
    payload: record,
});




// ====================== Delivery Challan  supplier   ===============================

export const getDeliveryChallanList = (record) => {
    return {
        type: GET_DELIVERY_CHALLAN_LIST_PROGRESS,
        payload: record,
    };
}

export const addDeliveryChallan = (record) => ({
    type: ADD_DELIVERY_CHALLAN_PROGRESS,
    payload: record,
});

export const editDeleteDeliveryChallan = (record) => ({
    type: EDIT_DELETE_DELIVERY_CHALLAN_PROGRESS,
    payload: record,
});

// ====================== Delivery Order   ===============================

export const getDeliveryOrderList = (record) => {
    return {
        type: GET_DELIVERY_ORDER_LIST_PROGRESS,
        payload: record,
    };
}

export const addDeliveryOrder = (record) => ({
    type: ADD_DELIVERY_ORDER_PROGRESS,
    payload: record,
});

export const editDeleteDeliveryOrder = (record) => ({
    type: EDIT_DELETE_DELIVERY_ORDER_PROGRESS,
    payload: record,
});


// ====================== GRN ===============================
export const getGrnList = (record) => {
    return {
        type: GET_GRN_LIST_PROGRESS,
        payload: record,
    };
}

export const addGrn = (record) => ({
    type: ADD_GRN_PROGRESS,
    payload: record,
});

export const editDeleteGrn = (record) => ({
    type: EDIT_DELETE_GRN_PROGRESS,
    payload: record,
});


// ====================== Production Entries =============================

// ----------------------- schedule entry-------------------------//

export const getScheduleEntryList = (record) => {
    return {
        type: GET_SCHEDULE_ENTRY_LIST_PROGRESS,
        payload: record,
    };
}

export const addScheduleEntry = (record) => ({
    type: ADD_SCHEDULE_ENTRY_PROGRESS,
    payload: record,
});

export const editDeleteScheduleEntry = (record) => ({
    type: EDIT_DELETE_SCHEDULE_ENTRY_PROGRESS,
    payload: record,
});

// ----------------------- Production Planning -------------------------//

export const getProductionPlanningList = (record) => {
    return {
        type: GET_PRODUCTION_PLANNING_LIST_PROGRESS,
        payload: record,
    };
}

export const addProductionPlanning = (record) => ({
    type: ADD_PRODUCTION_PLANNING_PROGRESS,
    payload: record,
});

export const editDeleteProductionPlanning = (record) => ({
    type: EDIT_DELETE_PRODUCTION_PLANNING_PROGRESS,
    payload: record,
});

// ----------------------- Production Entry -------------------------//

export const getProductionEntryList = (record) => {
    return {
        type: GET_PRODUCTION_ENTRY_LIST_PROGRESS,
        payload: record,
    };
}

export const addProductionEntry = (record) => ({
    type: ADD_PRODUCTION_ENTRY_PROGRESS,
    payload: record,
});

export const editDeleteProductionEntry = (record) => ({
    type: EDIT_DELETE_PRODUCTION_ENTRY_PROGRESS,
    payload: record,
});

// ----------------------- Quality Entry -------------------------//

export const getQualityEntryList = (record) => {
    return {
        type: GET_QUALITY_ENTRY_LIST_PROGRESS,
        payload: record,
    };
}

export const addQualityEntry = (record) => ({
    type: ADD_QUALITY_ENTRY_PROGRESS,
    payload: record,
});

export const editDeleteQualityEntry = (record) => ({
    type: EDIT_DELETE_QUALITY_ENTRY_PROGRESS,
    payload: record,
});



// ====================== Store Entries =============================

// ====================== Empty Cylinder Inward Master ===============================

export const getEciList = (record) => {
    return {
        type: GET_ECI_LIST_PROGRESS,
        payload: record,
    };
}

export const addEci = (record) => ({
    type: ADD_ECI_PROGRESS,
    payload: record,
});

export const editDeleteEci = (record) => ({
    type: EDIT_DELETE_ECI_PROGRESS,
    payload: record,
});


// ----------------------- Cylinder Inward -------------------------//

export const getCylinderInwardList = (record) => {
    return {
        type: GET_CYLINDER_INWARD_LIST_PROGRESS,
        payload: record,
    };
}

export const addCylinderInward = (record) => ({
    type: ADD_CYLINDER_INWARD_PROGRESS,
    payload: record,
});

export const editDeleteCylinderInward = (record) => ({
    type: EDIT_DELETE_CYLINDER_INWARD_PROGRESS,
    payload: record,
});


// ----------------------- Internal Movement Entry -------------------------//

export const getInternalMovementList = (record) => {
    return {
        type: GET_INTERNAL_MOVEMENT_LIST_PROGRESS,
        payload: record,
    };
}

export const addInternalMovement = (record) => ({
    type: ADD_INTERNAL_MOVEMENT_PROGRESS,
    payload: record,
});

export const editDeleteInternalMovement = (record) => ({
    type: EDIT_DELETE_INTERNAL_MOVEMENT_PROGRESS,
    payload: record,
});




// ====================== Sales Entries =============================

// ----------------------- Entries -------------------------//

// ----------------------- Customer PO -------------------------//

export const getCustomerPoList = (record) => {
    return {
        type: GET_CUSTOMER_PO_LIST_PROGRESS,
        payload: record,
    };
}

export const addCustomerPo = (record) => ({
    type: ADD_CUSTOMER_PO_PROGRESS,
    payload: record,
});

export const editDeleteCustomerPo = (record) => ({
    type: EDIT_DELETE_CUSTOMER_PO_PROGRESS,
    payload: record,
});


// ======================    Utility    ===============================
// ====================== BOM   ===============================

export const getBomList = (record) => {
    return {
        type: GET_BOM_LIST_PROGRESS,
        payload: record,
    };
}

export const addBom = (record) => ({
    type: ADD_BOM_PROGRESS,
    payload: record,
});

export const editDeleteBom = (record) => ({
    type: EDIT_DELETE_BOM_PROGRESS,
    payload: record,
});


// ======================  PICKUP ENTRY  ===============================

export const getPickupList = (record) => {
    return {
        type: GET_PICKUP_LIST_PROGRESS,
        payload: record,
    };
}

export const addPickup = (record) => ({
    type: ADD_PICKUP_PROGRESS,
    payload: record,
});

export const editDeletePickup = (record) => ({
    type: EDIT_DELETE_PICKUP_PROGRESS,
    payload: record,
});